"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const ElementTabs_vue_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/vue/components/ElementTabs.vue"));
const RankingCards_vue_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/vue/components/RankingCards.vue"));
const RankingBarchart_vue_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/vue/components/RankingBarchart.vue"));
const RankingOrderBy_vue_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/vue/components/RankingOrderBy.vue"));
const RankingDirection_vue_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/vue/components/RankingDirection.vue"));
const BioPhChTabs_vue_1 = __importDefault(require("@becrop/components/Results/Common/BioPhChTabs.vue"));
const SummaryPercentsPhch_vue_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/vue/components/phch/SummaryPercentsPhch.vue"));
let VariationRanking = class VariationRanking extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.categoryElement = this.previousCategoryElement;
        this.orderDesc = true;
        this.orderCriteria = 'variation';
        this.shortMode = true;
        this.activeMetrics = [];
        // To show the boxplot
        this.selectedMetric = null;
    }
    mounted() {
        this.changeCategoryElement();
        this.changeDimensionMetrics();
        this.emitDimension();
    }
    get allMetrics() {
        if (this.currentDimension === 'bio') {
            return this.bpe.getMetricCategory('all').metrics;
        }
        if (this.currentDimension === 'phch') {
            return this.bpe.getMetricCategory('phch').metrics;
        }
    }
    get topIncrements() {
        const allIncrements = this.allMetrics
            .filter((metric) => metric.becropScoreChange > 0)
            .map((met) => met);
        return allIncrements
            .sort((a, b) => b.becropScoreChange - a.becropScoreChange)
            .slice(0, 5);
    }
    get topDecrements() {
        const allDecrements = this.allMetrics
            .filter((metric) => metric.becropScoreChange < 0)
            .map((met) => met);
        return allDecrements
            .sort((a, b) => a.becropScoreChange - b.becropScoreChange)
            .slice(0, 5);
    }
    get clusterNames() {
        const myClusters = this.bpe.clusters.map((cl, i) => {
            if (cl.name.length === 0)
                return 'Cluster ' + (i + 1);
            else
                return cl.name;
        });
        return myClusters;
    }
    emitDimension() {
        this.$emit('updateDimension', this.currentDimension);
    }
    switchDimension(dimension) {
        this.$emit('updateDimension', dimension);
    }
    updateBarChart() {
        this.orderDesc
            ? this.activeMetrics.sort((a, b) => b.becropScoreChange - a.becropScoreChange)
            : this.activeMetrics.sort((a, b) => a.becropScoreChange - b.becropScoreChange);
    }
    changeBarDirection(d) {
        d === 'asc' ? (this.orderDesc = false) : (this.orderDesc = true);
        this.updateBarChart();
    }
    changeBarCriteria(d) {
        d === 'variation'
            ? (this.orderCriteria = d)
            : d === 'qv'
                ? (this.orderCriteria = d)
                : (this.orderCriteria = 'default');
        this.updateBarChart();
    }
    onToggle() {
        this.shortMode = !this.shortMode;
    }
    launchTheMetric(name) {
        let metric;
        if (this.currentDimension === 'phch') {
            metric = this.bpe.metrics.find((m) => m.code === name);
        }
        else {
            metric = this.bpe.metrics.find((m) => m.name === name);
        }
        this.selectedMetric = metric;
        this.emitMetric(metric);
    }
    emitMetric(metric) {
        this.$emit('launchBoxPlot', metric);
    }
    emitChangeCategory(category) {
        this.$emit('changeCategory', category);
    }
    changeCategoryElement() {
        if (this.currentDimension === 'bio') {
            this.activeMetrics = this.bpe.getMetricCategory(this.categoryElement).metrics;
        }
        if (this.currentDimension === 'phch') {
            this.activeMetrics = this.bpe
                .getMetricCategory('phch')
                .metrics.filter((metric) => !isNaN(metric.becropScoreChange));
        }
        this.emitChangeCategory(this.categoryElement);
    }
    changeDimensionMetrics() {
        if (this.currentDimension === 'bio') {
            this.activeMetrics = this.bpe.getMetricCategory(this.categoryElement).metrics;
        }
        if (this.currentDimension === 'phch') {
            this.activeMetrics = this.bpe
                .getMetricCategory('phch')
                .metrics.filter((metric) => !isNaN(metric.becropScoreChange));
            this.activeMetrics.sort((a, b) => b.becropScoreChange - a.becropScoreChange);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], VariationRanking.prototype, "bpe", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], VariationRanking.prototype, "previousCategoryElement", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], VariationRanking.prototype, "isPhchDimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], VariationRanking.prototype, "metricsPhch", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false })
], VariationRanking.prototype, "hasPhch", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], VariationRanking.prototype, "currentDimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('currentDimension')
], VariationRanking.prototype, "emitDimension", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('categoryElement')
], VariationRanking.prototype, "changeCategoryElement", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('currentDimension')
], VariationRanking.prototype, "changeDimensionMetrics", null);
VariationRanking = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ElementTabs: ElementTabs_vue_1.default,
            RankingCards: RankingCards_vue_1.default,
            RankingBarchart: RankingBarchart_vue_1.default,
            RankingOrderBy: RankingOrderBy_vue_1.default,
            RankingDirection: RankingDirection_vue_1.default,
            BioPhChTabs: BioPhChTabs_vue_1.default,
            SummaryPercentsPhch: SummaryPercentsPhch_vue_1.default,
        },
    })
], VariationRanking);
exports.default = VariationRanking;
